import React, { useState, useEffect } from 'react'
import Grid from '@material-ui/core/Grid'
import { ResponsiveContainer } from 'recharts'

import { Moment } from 'config/moment'
import { useApiCall } from 'hooks'
import { ERRORS } from 'consts'
import { snackbar } from 'components'

import {
  GetDataUserStatusDashboadResponse,
  DataUserStatusDashboad,
  ParametersDownload,
} from '../types'
import { getUserStatus } from '../api'
import { CustomPieChart } from './CustomPieChart'
import { useStyles } from '../styles'

const USER_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  ABANDONER: 'ABANDONER',
  LOST: 'LOST',
  NOT_YET: 'NOT_YET',
}

const ACTIVE_CODES = [USER_STATUS.ACTIVE]
const INACTIVE_CODES = [
  USER_STATUS.INACTIVE,
  USER_STATUS.ABANDONER,
  USER_STATUS.LOST,
  USER_STATUS.NOT_YET,
]

interface propsUsersStatus {
  startDate: Moment
  endDate: Moment
}

interface ChartData {
  name: string
  value: number
}

const pickByCodes = (rows: DataUserStatusDashboad[], codes: string[]): DataUserStatusDashboad[] =>
  codes
    .map(code => rows.find(obj => obj.code === code))
    .filter((obj): obj is DataUserStatusDashboad => Boolean(obj))

const sumValues = (rows: DataUserStatusDashboad[]): number =>
  rows.reduce((accumulator, row) => accumulator + row.value, 0)

const ActiveVsInactiveUser: React.FC<propsUsersStatus> = ({ startDate, endDate }) => {
  const classes = useStyles()
  const [requestUsersTags] = useApiCall<ParametersDownload, GetDataUserStatusDashboadResponse>(() =>
    getUserStatus({ startDate, endDate }),
  )
  const [activeVsInactive, setActiveVsInactive] = useState<ChartData[]>([])
  const [actives, setActives] = useState<DataUserStatusDashboad[] | []>([])
  const [inactives, setInactives] = useState<DataUserStatusDashboad[] | []>([])

  useEffect(() => {
    requestUsersTags({ startDate, endDate })
      .then(resp => {
        const activeUsers = pickByCodes(resp.data, ACTIVE_CODES)
        const inactiveUsers = pickByCodes(resp.data, INACTIVE_CODES)
        setActives(activeUsers.filter(obj => obj.value > 0))
        setInactives(inactiveUsers.filter(obj => obj.value > 0))
        const countActives = sumValues(activeUsers)
        const countInactives = sumValues(inactiveUsers)
        setActiveVsInactive(
          [
            { name: 'Activos', value: countActives },
            { name: 'Inactivos', value: countInactives },
          ].filter(obj => obj.value > 0),
        )
      })
      .catch(() => {
        setActives([])
        setInactives([])
        setActiveVsInactive([])

        snackbar.show(ERRORS.GENERIC_ERROR_MESSAGE)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate])

  return (
    <ResponsiveContainer width="100%">
      <Grid
        container
        item
        md={12}
        style={{ paddingTop: 20, paddingBottom: 20 }}
        className={classes.chartBody}
      >
        <Grid item md={4}>
          {' '}
          <CustomPieChart data={activeVsInactive} title="Activos vs Inactivos" />
        </Grid>
        <Grid item md={4}>
          {' '}
          <CustomPieChart data={actives} title="Activos" />
        </Grid>
        <Grid item md={4}>
          {' '}
          <CustomPieChart data={inactives} title="Inactivos" />
        </Grid>
      </Grid>
    </ResponsiveContainer>
  )
}
export { ActiveVsInactiveUser }
